// extracted by mini-css-extract-plugin
module.exports = {"audioPlayer":"LitresAudioPlayer_audioPlayer__QhjQ6"};